import React from "react";
import { TextField } from "@mui/material";
import { getIn } from "formik";

class TextfieldWrapper extends React.Component {
  handleChange = (value) => {
    const { name, onChange } = this.props;
    onChange(name, value.target.value);
  };

  handleBlur = () => {
    const { name, onBlur } = this.props;
    if (onBlur) {
      onBlur(name, true);
    }
  };

  render() {
    const { touched, errors, name, value, ...attributes } = this.props;
    const err = getIn(errors, name);
    const touch = getIn(touched, name);

    const configTextfield = {
      ...attributes,
      fullWidth: true,
      variant: "outlined",
      onChange: this.handleChange,
      onBlur: this.handleBlur,
      helperText: touch && err ? err : null,
    };

    return <TextField {...configTextfield} />;
  }
}

export default TextfieldWrapper;
